// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"c37f334c","977":"2763fa8e"}[chunkId] + ".chunk.js";
};